import { ApplicationListRequestParams } from './shared-models';

export class OwnerChangeRequestBulk {
  ApplicationParams: ApplicationListRequestParams;
  MuteNotification: boolean;
  NewOwnerUsername: string;
}
